import request from '../request';


/**
 * 网站提问
 */
export function question(data) {
    return request({
        url: '/zs/question/addWebQuestion',
        method: 'POST',
        data: data
    })
}

/***
 * 提问可邀请回答专家
 */
export function queryExpertList(obj) {
    return request({
        url: '/zs/question/queryExpertList',
        method: 'get',
        params:obj
    })
}

/**
 * 问答详情
 */
export function questionDetail(obj) {
    return request({
        url: '/zs/question/queryWebQuestionInfo',
        method: 'get',
        params: obj
    })
}

/**
 * 问题列表分页
 */
export function questionList(obj) {
    return request({
        url: '/zs/question/queryWebQuestionPage',
        method: 'get',
        params: obj
    })
}

/**
 * 图片上传
 */
// export function uploadPicture(data) {
//     return request({
//         url: '/zs/common/uploadPicture',
//         method: 'POST',
//         data,
        
//     })
// }
/**
 * 评论问题
 */
export function addWebAnswer(obj){
    return request({
        url:'/zs/answer/addWebAnswer',
        method:'POST',
        data:obj,
    })
}
/**
 * 回复评论
 */
export function addWebComment(obj){
    return request({
        url:'/zs/answer/addWebComment',
        method:'POST',
        data:obj,
    })
}
/**
 * 查看更多评论
 */
export function commitList(obj){
    return request({
        url:'/zs/answer/queryWebAnswerPage',
        method:'GET',
        params:obj,
    })
}
/**
 * 查看更多回复
 */
export function commitReply(obj){
    return request({
        url:'/zs/answer/queryWebCommentPage',
        method:'GET',
        params:obj,
    })
}

/**
 * 点赞
 */
export function updateAgree(obj){
    return request({
        url:'/zs/answer/updateAgree',
        method:'POST',
        data:obj,
    })
}

/**
 * 数据字典查询
 */
export function queryDataDict(obj){
    return request({
        url:'/zs/common/queryDataDict',
        method:'GET',
        params:obj
    })
}


// WEBPACK FOOTER //
// ./src/api/http/question.js